import { useEffect, useRef } from 'react';

export default function useAutoSave(formData, onSave, delay = 30000) {
  const timeoutRef = useRef(null);
  const previousDataRef = useRef(null);

  useEffect(() => {
    // Skip if data hasn't changed
    if (JSON.stringify(formData) === JSON.stringify(previousDataRef.current)) {
      return;
    }

    // Clear existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set new timeout
    timeoutRef.current = setTimeout(() => {
      // Only save if we have a title (minimum requirement)
      if (formData.title && formData.title.trim()) {
        onSave(true); // true indicates auto-save
        previousDataRef.current = formData;
      }
    }, delay);

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [formData, onSave, delay]);

  return null;
}
